import { Typography, useTheme } from "@mui/material";
import "./Headlines.css"

export function H2({ children }: { children: string }) {
  const theme = useTheme();
  return (
    <Typography
      variant="h2"
      align="left"
      color={theme.palette.secondary.contrastText}
      className="h2"
      fontSize={24}
      fontWeight={400}
    >
      {children}
    </Typography>
  );
}
